import { CAT_RECOMMENDED_PRODUCTS } from 'App/utils/Collections';

export default {
  category: CAT_RECOMMENDED_PRODUCTS,
  filters: [],
  searchBarProp: 'name',
};
